module.exports = __webpack_public_path__ + "static/with-the-old-breed-at-peleliu-and-okinawa-72bbb20c53612d978ee4513b2982294a.jpg";